'use strict';

angular.module('userRequestEditControllers')

.controller('LocationEquipmentController',
            ['$scope',  'selfAccessRequestService','userRequest',
function ($scope, selfAccessRequestService, userRequest) {
    
        $scope.userRequest = userRequest;

        // Populate Checkboxes
        selfAccessRequestService.getSelfAccessRequestLookups()
            .then(function (lookUps) {

                $scope.computerTypes = lookUps.ComputerTypes;

                //Select Current checkbox if any
                _.forEach($scope.computerTypes, function (computerType) {

                    if (computerType.ReferenceDataID == userRequest.LocationComputerTypeID) {
                        computerType.isSelected = true;
                        $scope.userRequest.LocationComputerTypeID = computerType.ReferenceDataID
                        return;
                    }
                    
                    computerType.isSelected = false;
                })
            });


}]);
